module.exports = __webpack_public_path__ + "static/media/023-tooth whitening.3f2a047f.svg";